export const images = 
  {
    jota: "../../image/Logo_Jota.png",
    patri: "../../image/Logo_Patri.png",
  };

